import React, {useEffect, useState} from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { apiCallBegan } from '../store/api'
import { FaRegCalendarAlt } from '@react-icons/all-files/fa/FaRegCalendarAlt'
import { FaAsterisk } from '@react-icons/all-files/fa/FaAsterisk'
import { AiFillBank } from '@react-icons/all-files/ai/AiFillBank'
import { AiOutlinePhone } from '@react-icons/all-files/ai/AiOutlinePhone'
import { AiOutlineMail } from '@react-icons/all-files/ai/AiOutlineMail'
import { AiOutlineUser } from '@react-icons/all-files/ai/AiOutlineUser'
import { FaBuilding } from '@react-icons/all-files/fa/FaBuilding'
import { MdLocationOn } from '@react-icons/all-files/md/MdLocationOn'
import { FaRegBuilding } from '@react-icons/all-files/fa/FaRegBuilding'
import Button from './Button';
import Clickable from './Clickable';
import StateSelect from './StateSelect';
import { helper } from '../utilities/helper';
import { showAlert } from '../store/slices/ui';
import { refreshURL } from '../store/slices/cache'
import { getUser } from '../store/slices/user';
const SignContact = ({potential, setStep}) => {
    let dispatch = useDispatch()
    let {handleSubmit, register, setValue, errors} = useForm()
    let [selected, setSelected] = useState()
    let {user} = useSelector(getUser)
    let [er, setErr] = useState(0)

    useEffect(() => {
        console.log(potential?.main_contact)
        if(potential?.main_contact) {
            setValue('first_name', potential?.main_contact?.first_name)
            setValue('last_name', potential?.main_contact?.last_name)
            setValue('phone', potential?.main_contact?.phone)
            setValue('email', potential?.main_contact?.email)
        } else if(user?._id && !user.employee) {
            setValue('first_name', user?.first_name)
            setValue('last_name', user?.last_name)
            setValue('phone', user?.phone)
            setValue('email', user?.email)
        }

    }, [potential])




    let submit = data => {






        if(potential?.main_contact?._id) {
            dispatch(apiCallBegan({ url: `/business/add-user/${potential?._id}`, method: 'POST', data: {...data, main_id:potential?.main_contact?._id } , showSpinner: true, onExtFunc: () => {
                dispatch(refreshURL(`/business/withContacts/${potential?._id}`))
                setStep((potential?.model?.two || potential?.model?.four ) ? 3: 4)
            }  }))
        } else {
            data.business = potential?._id
            if(!user.employee && user.email === data.email) {
                data.user = user._id
            }
            dispatch(apiCallBegan({ url: `/businessContact`, method: 'POST', data , showSpinner: true,  onSuccessFunc: bc =>      apiCallBegan({ url: `/business/edits/${potential?._id}`, method: 'PUT', data: {main_contact: bc._id} , showSpinner: true, onExtFunc: () => {
               dispatch(apiCallBegan({url: `/user/edits/${user._id}`, data: {business: potential?._id}}))
                dispatch(refreshURL(`/business/withContacts/${potential?._id}`))
                setStep((potential?.model?.two || potential?.model?.four ) ? 3: 4)
            } }) }))

        }

    }



    if(potential?.main_contact?.user) return <div>
              <div className='buttons'>

        </div>
    </div>



    return <form className="signCont" onSubmit={handleSubmit(submit)}>
        <div className="row">

                <div className={`inputIcon`}>
                    <input  id="first_name" name="first_name"  placeholder='First Name' ref={register({required: 'Please input main contact first name'})} />
                    <label id="first_name" htmlFor='first_name' ><AiOutlineUser /></label>

                            {errors.first_name && <strong className='colorText red' >{errors.first_name?.message}</strong>}
                </div>


                <div className={`inputIcon`}>
                    <input  id="last_name" name="last_name"  placeholder='Last Name'  ref={register({required: 'Please input your last name'})}  />
                    <label id="last_name" htmlFor='last_name' ></label>

                            {errors.last_name && <strong className='colorText red' >{errors.last_name?.message}</strong>}
                </div>


        </div>
        <div className="row">

                <div className={`inputIcon`}>
                    <input  id="email" name="email"  placeholder='Email' ref={register({required: 'Please input your email '})} />
                    <label id="email" htmlFor='email' ><AiOutlineMail /></label>

                            {errors.email && <strong className='colorText red' >{errors.email?.message}</strong>}
                </div>


                <div className={`inputIcon`}>
                    <input  id="phone" name='phone' placeholder='Phone'  ref={register({required: 'Please input your phone number'})}  />
                    <label id="phone" htmlFor='phone' ><AiOutlinePhone /></label>

                            {errors.phone && <strong className='colorText red' >{errors.phone?.message}</strong>}
                </div>


        </div>



        <div className='buttons'>
            <Button onClick={()=> setErr(e=> e+1)} className='btn-4  highLight'>Continue</Button>
        </div>
    </form>
}

export default SignContact